import { Box, Grid, Typography } from '@mui/material';

const FlightSegment = ({
  segment,
  labelStyle,
  returnTime,
  findScale,
  flightTimeConvert,
}) => {
  if (!segment) return null;

  return (
    <Box>
      <Grid container style={{ display: 'flex', alignItems: 'center' }}>
        <Grid item xs={4}>
          <Typography sx={labelStyle}>
            {returnTime(segment?.departure)}
          </Typography>
        </Grid>
        <Grid item xs={4} sx={{ color: '#000', fontSize: '16px' }}>
          {findScale(segment)}
        </Grid>
        <Grid item xs={4}>
          <Typography sx={labelStyle}>
            {returnTime(segment?.arrival)}
          </Typography>
        </Grid>
      </Grid>

      <Grid container style={{ display: 'flex', alignItems: 'center' }}>
        <Grid item xs={4}>
          <Typography sx={{ color: '#636466', fontSize: '16px' }}>
            {segment?.origin_airport}
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          sx={{ color: '#000', fontSize: '12px', lineHeight: 1 }}
        >
          {flightTimeConvert(segment?.flight_time)}
        </Grid>
        <Grid item xs={4}>
          <Typography sx={{ color: '#636466', fontSize: '16px' }}>
            {segment?.destination_airport}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FlightSegment;
